/*
Jitbit TabUtils - helper for multiple browser tabs. version 1.0
https://github.com/jitbit/TabUtils
- executing "interlocked" function call - only once per multiple tabs
- broadcasting a message to all tabs (including the current one) with some message "data"
- handling a broadcasted message
MIT license: https://github.com/jitbit/TabUtils/blob/master/LICENSE
*/
import uuid from 'uuid-random';

const tabUtils = new (function () {
  let keyPrefix = '_tabutils_'; //just a unique id for key-naming

  //runs code only once in multiple tabs
  //the lock holds for 4 seconds (in case the function is async and returns right away, for example, an ajax call intiated)
  //then it is cleared
  this.callOnce = function (lockname, fn, timeout) {
    timeout = timeout || 3000; //lock held for 3 seconds by default

    if (!lockname) throw new Error('empty lockname');

    if (!window.localStorage) {
      //no local storage. old browser. just run the function
      fn();
      return;
    }

    let localStorageKey = keyPrefix + lockname;

    localStorage.setItem(localStorageKey, tabID);
    //re-read after a delay (after all tabs have saved their tabIDs into ls)
    setTimeout(function () {
      if (localStorage.getItem(localStorageKey) === tabID) fn();
    }, 300);

    //cleanup - release the lock after 3 seconds and on window unload (just in case user closed the window while the lock is still held)
    setTimeout(function () {
      localStorage.removeItem(localStorageKey);
    }, timeout);
  };

  let tabID = performance.now() + ':' + uuid();
})();

export default tabUtils;
